var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SearchTable',{ref:"table",attrs:{"header":{
    title: 'Ponude',
    icon: 'sticky_note_2',
    class: 'md-card-header-brand',
  },"queriedData":_vm.offers,"metaData":_vm.metaData,"getItems":_vm.getOfferLogs,"openItem":_vm.openOfferLog,"params":_vm.params,"sortBy":'id',"individualFunction":[
    {
      icon: 'print',
      class: 'md-primary md-simple',
      function: _vm.getOfferLogPdf,
    } ]}})}
var staticRenderFns = []

export { render, staticRenderFns }